import { render, staticRenderFns } from "./assign_user.vue?vue&type=template&id=be1b35b0&"
import script from "./assign_user.vue?vue&type=script&lang=js&"
export * from "./assign_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports